import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatSelectChange } from '@angular/material/select';
import { AccountEditPayload, ReservationPreview } from '@app/modules/statements/models/statements.models';
import { StatementsFacade } from '@app/modules/statements/services/statements.facade';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sbnb-dialog-preview-accounting',
  templateUrl: './dialog-preview-accounting.component.html',
  styleUrls: ['./dialog-preview-accounting.component.scss'],
})
export class DialogPreviewAccountingComponent {
  public reservationsState$ = this.statementsFacade.reservationsState$;
  public loadingPreview$ = new BehaviorSubject<boolean>(false);
  public previewData$ = new BehaviorSubject<ReservationPreview>(null);

  constructor(
    private statementsFacade: StatementsFacade,
    private dialogRef: MatDialogRef<DialogPreviewAccountingComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      connectionId: number;
      accountMapping: AccountEditPayload;
    }
  ) {
    this.statementsFacade.listReservations();
  }

  public onReservationSelect(event: MatSelectChange): void {
    const selectedReservationId = event.value;
    const connectionId = this.data.connectionId;
    this.loadingPreview$.next(true);

    this.statementsFacade
      .previewReservation(connectionId, selectedReservationId, {
        accounts: this.data.accountMapping.accounts,
      })
      .subscribe((data) => {
        this.previewData$.next(data);
        this.loadingPreview$.next(false);
      });
  }

  public closePreview(): void {
    this.dialogRef.close();
  }
}
